
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form/[slug]",
      function () {
        return require("private-next-pages/form/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form/[slug]"])
      });
    }
  